export const snackbarType = {
  info: Symbol("info"),
  error: Symbol("error"),
  warning: Symbol("warning")
};
